export enum PcrTestHours {    
    //UseNkrStat = 0,
    Within02 = 2,
    Within03 = 3,
    Within04 = 4,
    Within05 = 5,
    Within06 = 6,
    Within12 = 12,
    Within24 = 24,
    Over24 = 25
}